// extracted by mini-css-extract-plugin
export var root = "BrandVisual-module--root--qz6Jx";